import { DateTime } from "luxon";
import { ServiceContractRef } from "../../shared/refs";

export interface ContractServiceConfirmation {
  success: boolean;
  dateOfService: number;
}

export interface ServiceObject {
  id?: string;
  startDate?: number;
  graceDate?: number;
  status?: string;
  dateOfService?: number;
  serviceContract?: ServiceContractRef;
  notes?: string;
}

export class Service {
  id?: string;
  startDate?: string;
  graceDate?: string;
  status?: string;
  dateOfService?: string;
  serviceContract?: ServiceContractRef;
  notes?: string;

  constructor(service: ServiceObject) {
    Object.assign(this, service);
    if (service.startDate) {
      const startDate = DateTime.fromMillis(service.startDate).toFormat("dd-MM-yyyy");
      this.startDate = startDate;
    }
    if (service.graceDate) {
      const graceDate = DateTime.fromMillis(service.graceDate).toFormat("dd-MM-yyyy");
      this.graceDate = graceDate;
    }
    if (service.dateOfService) {
      const dateOfService = DateTime.fromMillis(service.dateOfService).toFormat("dd-MM-yyyy");
      this.dateOfService = dateOfService;
    }
  }
}
